import { boxShadows } from '@eversports/design-tokens/box-shadows'
import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Popover from '@eversports/klimt-primitives/legacy/Popover'

import Drawer from '../../../../../../components/Drawer'

import ProfileVisibilitySettingActionItem from './ProfileVisibilitySettingActionItem'

interface Props {
  isOpen: boolean
  toggleDialog: () => void
  anchorEl: Element | null
}

const SettingsActions = ({ isOpen, anchorEl, toggleDialog }: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return isMobile ? (
    <Drawer open={isOpen} onClose={toggleDialog}>
      <ProfileVisibilitySettingActionItem />
    </Drawer>
  ) : (
    <Popover
      anchorEl={anchorEl}
      open={isOpen}
      onClose={toggleDialog}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      sx={{
        '& .MuiPopover-paper': {
          border: '1px solid',
          borderColor: 'mediumgray',
          boxShadow: boxShadows.hover,
          borderRadius: '0px 8px 8px 8px',
        },
        top: '8px',
      }}
    >
      <ProfileVisibilitySettingActionItem />
    </Popover>
  )
}

export default SettingsActions
